import { useLayoutEffect } from "react";
import "./Spinner.css";

function Spinner() {
  useLayoutEffect(() => {
    const pageLoader = document.getElementById("spinner");

    const animation = pageLoader.animate(
      [
        { opacity: "1" },
        { opacity: "0", offset: 0.5 },
        { opacity: "0", offset: 1 },
      ],
      {
        duration: 2000,
        easing: "linear",
        iterations: 1,
        direction: "normal",
        fill: "forwards",
        delay: 1,
        endDelay: 0,
      }
    );

    animation.onfinish = () => {
      pageLoader.style.display = "none";
      pageLoader.classList.remove("show");
    };
  }, []);

  return (
    <div
      id="spinner"
      className="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
    >
      <div
        className="spinner-border text-primary"
        style={style.spinnerBorder}
        role="status"
      >
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
}

const style = {
  spinnerBorder: { width: "3rem", height: "3rem" },
};

export default Spinner;
